import React from 'react'
import MediaMenuItem from '../MediaMenu/MediaMenuItem'
import SlideButtonProps from './types'
import { IconType } from '@bt-react/components/Icon'

const SlidesButton: React.FC<SlideButtonProps> = ({
  mediaDrawerOpen = false, isActive = false, isLoading = false,
  disabled = false, slidesCount = 0, tooltipText, closeMediaDrawer, openMediaDrawer
}) =>
  <MediaMenuItem
    onClick={mediaDrawerOpen ? closeMediaDrawer : openMediaDrawer}
    dataBdd={'talks-slides-button'}
    active={isActive}
    icon={isLoading ? IconType.iconName.spinner : IconType.iconName.image}
    text={`Slides`}
    disabled={disabled}
    tooltipText={tooltipText}
    notifications={slidesCount}
    mediaType='SLIDES'
  />

export default SlidesButton
